import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Header from "../Header/Header";
import HotelHero from "./HotelHero";
import BenefitsSection from "./BenefitsSection";
import EnrollmentSuccess from "./EnrollmentSuccess";
import Footer from "../Footer/Footer";
import Theme from "../UI/Theme";
import LazyLoad from "react-lazyload";
import { NotificationContainer } from "../UI/NotificationWrapper";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import HowItWorks from "./HowItWorks";
import { ThemeProvider } from "styled-components";
import { theme } from "../theme";
import CashRewardOptions from "./CashRewardOptions";
import RewardCalculation from "./RewardCalculation";
import AboutGuestbook from "./AboutGuestbook";
import Faq from "./Faq";

type HotelLandingProps = {
  userLoggedIn: boolean;
  languageCode: string;
  wid: string;
  hotelName: string;
  hotelCover: any;
  hotelUrl: string;
  hotelLoyalty: any;
  hotelLogo: any;
  logoMarginTop: any;
  loyaltyBenefits: any;
  captchaKey: string;
  enrollmentSource: string;
}

const HotelLanding = ({
  userLoggedIn,
  languageCode,
  wid,
  hotelName,
  hotelCover,
  hotelUrl,
  hotelLoyalty,
  hotelLogo,
  logoMarginTop,
  loyaltyBenefits,
  captchaKey,
  enrollmentSource,
}: HotelLandingProps) => {
  const [enrollmentSuccess, setEnrollmentSuccess] = useState(false);

  useEffect(() => {
    library.add(fas);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Container fluid>
        {!enrollmentSuccess ? (
          <>
            <Header
              isLoggedIn={userLoggedIn}
              isOutsideAccountDash={false}
              isHotelLanding={true}
              hotelUrl={hotelUrl}
              hotelLogo={hotelLogo}
              logoMarginTop={logoMarginTop}
            />
            <Theme>
              <NotificationContainer isPrivateLabel={false} />
              <HotelHero
                wid={wid}
                hotelName={hotelName}
                hotelCover={hotelCover}
                hotelLoyalty={hotelLoyalty}
                setEnrollmentSuccess={setEnrollmentSuccess}
                captchaKey={captchaKey}
                enrollmentSource={enrollmentSource}
              />
              {loyaltyBenefits && loyaltyBenefits.length > 0 ? (
                <LazyLoad offset={100}>
                  <BenefitsSection
                    hotelLoyalty={hotelLoyalty}
                    loyaltyBenefits={loyaltyBenefits}
                  />
                </LazyLoad>
              ) : null}
              <HowItWorks />
              <CashRewardOptions />
              <RewardCalculation />
              <AboutGuestbook />
              <Faq />

            </Theme>
            <LazyLoad offset={100}>
              <Footer
                languageCode={languageCode}
                wid={wid}
                isHotelLanding={true}
                fullPageFooter={false}
              />
            </LazyLoad>
          </>
        ) : (
          <Theme>
            <EnrollmentSuccess
              hotelName={hotelName}
              hotelUrl={hotelUrl}
            />
          </Theme>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default HotelLanding;
